import { useState, useRef, useCallback } from 'react';
import { Send, Mic, Square, X } from 'lucide-react';
import VoiceRecorder from '../voice/VoiceRecorder';
import type { ParsedCommand } from '../../types/voice';
interface InputAreaProps {
  onSendMessage: (text: string) => void;
  onCommand?: (command: ParsedCommand) => void;
  disabled?: boolean;
  placeholder?: string;
}

export default function InputArea({ 
  onSendMessage, 
  disabled = false,
  placeholder = 'Escribe un mensaje...'
}: InputAreaProps) {
  const [inputText, setInputText] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [transcript, setTranscript] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSend = useCallback(() => {
    if (inputText.trim() && !disabled) {
      console.log("send:",isRecording)
      onSendMessage(inputText.trim());
      if(isRecording){
          setIsRecording(false);
      }
      setInputText('');
      inputRef.current?.focus();
    }
  }, [inputText, disabled, onSendMessage]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleTranscript = (text: string) => {
    console.log(text)
    setTranscript(text);
    setInputText(text);
  };

  /*const handleCommand = (command: ParsedCommand) => {
    onCommand?.(command);
    setIsRecording(false);
    setTranscript('');
  };*/

  const toggleRecording = () => {
    if (isRecording) {
      setIsRecording(false);
      if (transcript.trim()) {
        onSendMessage(transcript.trim());
        setTranscript('');
        setInputText('');
      }
    } else {
      setIsRecording(true);
      setTranscript('');
    }
  };

  const cancelRecording = () => {
    setIsRecording(false);
    setTranscript('');
    setInputText('');
  };

  return (
    <div className="p-4 bg-base-100 border-t border-base-300">
      {isRecording ? (
        <div className="flex items-center gap-3">
          <VoiceRecorder
            isListening={isRecording}
            onTranscript={handleTranscript}
            onStartListening={() => setIsRecording(true)}
            onStopListening={() => setIsRecording(false)}
            showVisualizer={true}
          />
         
          
          <div className="flex-1 text-center">
            <p className="text-sm text-base-content/70">
              {transcript || 'Escuchando...'}
            </p>
          </div>
          
          <button
            onClick={toggleRecording}
            className="btn btn-primary btn-circle"
            aria-label="Enviar mensaje de voz"
          >
            <Send className="w-5 h-5" />
          </button>
          
          <button
            onClick={cancelRecording}
            className="btn btn-ghost btn-circle"
            aria-label="Cancelar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="flex-1 relative">
            <input
              ref={inputRef}
              type="text"
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={placeholder}
              disabled={disabled}
              className="input input-bordered w-full pr-12 rounded-full focus:input-primary"
            />
            {inputText && (
              <button
                onClick={() => setInputText('')}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-base-content/40 hover:text-base-content"
                aria-label="Limpiar"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
          
          <button
            onClick={toggleRecording}
            className={`btn btn-circle ${isRecording ? 'btn-error' : 'btn-ghost'}`}
            aria-label={isRecording ? 'Detener grabación' : 'Iniciar grabación de voz'}
          >
            {isRecording ? (
              <Square className="w-5 h-5" />
            ) : (
              <Mic className="w-5 h-5" />
            )}
          </button>
          
          <button
            onClick={handleSend}
            disabled={!inputText.trim() || disabled}
            className="btn btn-primary btn-circle"
            aria-label="Enviar mensaje"
          >
            <Send className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
}